import { z } from "zod";

export const editOfferFormDataSchema = z.object({
    customerIds: z.array(z.string().uuid()),
    discount: z.record(z.string().uuid(), z.number().min(0).max(100)),
    draftId: z.string().uuid().optional(),
    expireDate: z.date().optional(),
    email_body: z.string().optional(),
    email_subject: z.string().optional(),
});
